module.exports = __webpack_public_path__ + "static/media/alienCallig2.4eb3d879.jpeg";